module.exports = __webpack_public_path__ + "static/media/passenger-source.98010bc0.png";